'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _whiteLabel = require('../../../redux/modules/whiteLabel');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _WhiteLabelCrown = require('./WhiteLabelCrown');

var _WhiteLabelCrown2 = _interopRequireDefault(_WhiteLabelCrown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        siteName: (0, _whiteLabel.getWhiteLabelSiteName)(state),
        siteUrl: (0, _whiteLabel.getWhiteLabelSiteUrl)(state)
    };
};

var WhiteLabelCrownContainer = function (_PureComponent) {
    (0, _inherits3.default)(WhiteLabelCrownContainer, _PureComponent);

    function WhiteLabelCrownContainer() {
        (0, _classCallCheck3.default)(this, WhiteLabelCrownContainer);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelCrownContainer.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelCrownContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelCrownContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                siteName = _props.siteName,
                siteUrl = _props.siteUrl;


            return (0, _jsx3.default)(_WhiteLabelCrown2.default, {
                siteName: siteName,
                siteUrl: siteUrl
            });
        }
    }]);
    return WhiteLabelCrownContainer;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WhiteLabelCrownContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/WhiteLabelCrown/WhiteLabelCrownContainer.js
// module id = pf/a
// module chunks = 60